import CryptoJS from 'crypto-js';
import axios from 'axios';
import { btoa, atob } from '../../lib/helpers';

const assignment = {
  namespaced: true,

  state() {
    return {
      loading: false,
      errors: [],
      flashErrorMessage: '',
      flashError: false,
    };
  },

  mutations: {
    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setLoading(state, loading) {
      state.loading = loading;
    },
  },

  actions: {
    async assign(ctx, { date, parent, child }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        parent,
        child,
        version: btoa(
          CryptoJS.SHA256(
            parent +
              //     child +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/rbac/assignment/assign`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      return axios(config)
        .then((response) => {
          if (response.data.code != '200') {
            ctx.commit('setErrors', response.data.data);
            if (localStorage.getItem('language_qram') == null) {
              ctx.commit('setFlashErrorMessage', response.data.message_id);
            } else {
              ctx.commit('setFlashErrorMessage', response.data.message_en);
            }
            return false;
          }
          return true;
        })
        .catch((error) => {
          if (error.response.status == '403') {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: error.response.data.message,
                icon: 'mdi-alert',
                color: 'red',
              },
              { root: true }
            );
          } else if (error.response.status == '401') {
            ctx.dispatch('logout', null, { root: true });
          }
          return false;
        })
        .finally(() => {
          ctx.commit('setLoading', false);
        });
    },

    async revoke(ctx, { date, parent, child }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        parent,
        child,
        version: btoa(
          CryptoJS.SHA256(
            parent +
              //     child +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/rbac/assignment/revoke`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      return axios(config)
        .then((response) => {
          if (response.data.code != '200') {
            ctx.commit('setErrors', response.data.data);
            if (localStorage.getItem('language_qram') == null) {
              ctx.commit('setFlashErrorMessage', response.data.message_id);
            } else {
              ctx.commit('setFlashErrorMessage', response.data.message_en);
            }
            return false;
          }
          return true;
        })
        .catch((error) => {
          if (error.response.status == '403') {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: error.response.data.message,
                icon: 'mdi-alert',
                color: 'red',
              },
              { root: true }
            );
          } else if (error.response.status == '401') {
            ctx.dispatch('logout', null, { root: true });
          }
          return false;
        })
        .finally(() => {
          ctx.commit('setLoading', false);
        });
    },
  },
};
export default assignment;
